export enum AdminCourtSystemsParam {
  CourtSystemId = 'courtSystemId',
  RateLimit = 'rateLimit',
}
